import { render, staticRenderFns } from "./uploadtemplate.vue?vue&type=template&id=fb86d938"
import script from "./uploadtemplate.vue?vue&type=script&lang=js"
export * from "./uploadtemplate.vue?vue&type=script&lang=js"
import style0 from "./uploadtemplate.vue?vue&type=style&index=0&id=fb86d938&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports